import { getIn } from 'fun-util';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import FreeWriteBuilderEnum from 'FreeWriteBuilder/FreeWriteBuilderConstants';
import {
  calculatePopupImageDimensions,
  getOriginalSignFieldDimensions,
  isFilledPopup,
  isFilledSignPopup,
  isPopupAssignedToSigner,
  isRequestSignaturePopup,
  isRequestSignatureSignPopup,
  wasRequestSignaturePopup,
} from 'Popups/helpers';
import PopupConstants from '../PopupConstants';

export const DEFAULT_STATE = {};

const deletePopup = (state, action) => {
  const { [action.id]: extracted, ...remaining } = state;
  return remaining;
};

const deleteSharePopups = (state, action) =>
  Object.keys(state)
    .filter((popupId) => {
      const popup = state[popupId];
      if (action.signer) {
        return !isPopupAssignedToSigner(action.signer)(popup);
      }
      return !(isRequestSignaturePopup(popup) || wasRequestSignaturePopup(popup));
    })
    .reduce((remainingPopups, popupId) => ({
      ...remainingPopups,
      [popupId]: state[popupId],
    }), {});

const movePopup = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    x: action.x,
    y: action.y,
    zIndex: action.state.zIndex,
  },
});

const getESignSettings = (popup) => {
  const address = getIn(popup, 'requestSettings', 'address');
  if (address) {
    return { eSignSettings: { address } };
  }
  return {};
};

const unwrapPopup = (popups, popupId, popup) => {
  if (isRequestSignaturePopup(popup) && isFilledPopup(popup)) {
    const { requestType, requestSettings, contentSettings, ...baseAttributes } = popup;
    const eSignSettings = getESignSettings(popup);
    return {
      ...popups,
      [popupId]: { ...baseAttributes, ...contentSettings, ...eSignSettings },
    };
  }
  return { ...popups, [popupId]: popup };
};

const unwrapRequestSignaturePopups = state => Object.keys(state).reduce(
  (unwrappedPopups, popupId) => unwrapPopup(unwrappedPopups, popupId, state[popupId]),
  {},
);

const updateRequestSignatureContent = (state, action) => ({
  ...state,
  [action.popupID]: {
    ...state[action.popupID],
    contentSettings: {
      ...state[action.popupID].contentSettings,
      imageUrl: action.imgSrc,
    },
  },
});

const autofillPopup = (state, action) => {
  const { lastUsedImageUrl, popup } = action;
  if (lastUsedImageUrl) {
    if (isRequestSignatureSignPopup(popup) && !isFilledSignPopup(popup)) {
      return {
        ...state,
        [popup.id]: {
          ...popup,
          contentSettings: {
            ...popup.contentSettings,
            imageUrl: lastUsedImageUrl,
          },
        },
      };
    }
  }
  return state;
};

const clearSignaturePopup = (state, action) => {
  const popup = state[action.id];
  if (isRequestSignatureSignPopup(popup)) {
    return ({
      ...state,
      [action.id]: {
        ...popup,
        ...getOriginalSignFieldDimensions(popup),
        contentSettings: {
          ...popup.contentSettings,
          imageUrl: '',
          imgIdx: '',
        },
      },
    });
  }
  return state;
};

const updatePopupDimensions = (state, action) => {
  const { popup } = action;
  if (isRequestSignatureSignPopup(popup)) {
    return {
      ...state,
      [popup.id]: {
        ...popup,
        ...calculatePopupImageDimensions(action),
        requestSettings: {
          ...popup.requestSettings,
          ...getOriginalSignFieldDimensions(popup),
        },
      },
    };
  }
  return state;
};

const popups = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS:
      return getIn(action, 'data', 'custom_template', 'field_outline', 'fields') || {};
    case FreeWriteBuilderEnum.FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_SUCCESS:
      return action.data.popups;
    case PopupConstants.CHANGE_POPUP:
      return { ...state, [action.id]: { ...state[action.id], ...action.attributes } };
    case PopupConstants.CREATE_POPUP:
      return { ...state, [action.id]: action.data };
    case PopupConstants.DELETE_POPUP:
    case PopupConstants.GROUP_POPUP_DELETE:
      return deletePopup(state, action);
    case PopupConstants.MOVE_POPUP:
      return movePopup(state, action);
    case PopupConstants.DELETE_SHARE_POPUPS:
      return deleteSharePopups(state, action);
    case PopupConstants.SIGNATURE_POPUP_CLEAR:
      return clearSignaturePopup(state, action);
    case PopupConstants.UNWRAP_REQUEST_SIGNATURE_POPUPS:
      return unwrapRequestSignaturePopups(state);
    case PopupConstants.UPDATE_REQUEST_SIGNATURE_CONTENT:
      return updateRequestSignatureContent(state, action);
    case PopupConstants.ACTIVATE_NEXT_UNFILLED_POPUP:
    case PopupConstants.POPUP_DIRECT_SELECT:
      return autofillPopup(state, action);
    case PopupConstants.POPUP_IMAGE_LOADED:
      return updatePopupDimensions(state, action);
    default:
      return state;
  }
};

export default popups;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupsReducer/popups.jsx